import { string } from 'prop-types'

export default {
  canonicalUrl: string,
  id: string,
  name: string,
}
